<template>
	<div>
		<firstsceenimage :imgobj='bigimage'></firstsceenimage>


		<div ref="adimgref">
			<adword title="专业的制鞋数字材料库" slotheight="600">
				<div class="container" style="text-align: left;">
					<div class="row">
						<div class="col-md-6">
							<transition name="adfadex1">
								<img class="bookclubimge1" v-if="adimgshow"
									src="../../static/组 3.png" />
							</transition>
							<div v-if="!adimgshow" style="height: 590px;"> </div>
						</div>

						<!-- <transition name="adfadex2"> -->
						<div class="col-md-4 boxshadow" :style="{backgroundImage: 'url('+backimg+') ' }"
							style="background-repeat:no-repeat; background-position:right bottom ; padding: 21px 100px 0px 21px;; margin: 80px;">
							<div>
								<div style="background-repeat:no-repeat; background-position:left bottom ;margin-bottom:10px ; font-size: 18px;font-weight: bold;letter-spacing: 4px;color: color: #333333;"
									:style="{backgroundImage: 'url('+blueimg+') ' }">
									强大扫描与计算能力
								</div>
								<div style="color: #999999;font-size: 12px;letter-spacing: 3px;line-height: 18px;">
									借助3d材料扫描仪以及华为云强大的计算能力快速生成高品质数字材料令海量素材得以云端存储
								</div>
							</div>
							<div style="margin-top: 27px;">
								<div style="background-repeat:no-repeat; background-position:left bottom ;margin-bottom:10px ; font-size: 18px;font-weight: bold;letter-spacing: 4px;color: color: #333333;"
									:style="{backgroundImage: 'url('+blueimg+') ' }">
									最新UV坐标投影贴图技术
								</div>
								<div style="color: #999999;font-size: 12px;letter-spacing: 3px;line-height: 18px;">
									合作研发高效的UV展平技术让材质在任何不规则模型上展示最优呈现效果
								</div>
							</div>
							<div style="margin-top: 27px;">
								<div style="background-repeat:no-repeat; background-position:left bottom ;margin-bottom:10px ; font-size: 18px;font-weight: bold;letter-spacing: 4px;color: color: #333333;"
									:style="{backgroundImage: 'url('+blueimg+') ' }">
									数字化展示
								</div>
								<div style="color: #999999;font-size: 12px;letter-spacing: 3px;line-height: 18px;">
									采用多样3D模型展示，面料细节真实可见以高精建模+实时渲染展示面料效果真正打破现实与虚拟的隔墙
								</div>
							</div>
						</div>
						<!-- </transition> -->

					</div>
				</div>
			</adword>
		</div>

		<adword style="background-color: #F8F8F8;" title="更多数字化知识库" subtitle="数字化材料数据库，除了面料库，还包括楦头库、跟底库、型体库、配件库等。
强大的数字化材料库，便于实现产品的数字化设计和开发，提高设计效率、降低研发成本。" slotheight="700">
			<div class="flexcenter" style="padding: 50px 50px 10px 50px;">
				<div @mouseenter="swimg(0)"
					style="position: relative;width: 226px;height: 507px; overflow: hidden; margin-bottom:30px ">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;">
						<div
							style="margin-top: 150px;margin-left: 100px; width: 5px; line-height: 260%;	font-size: 25px; font-weight: bold;height: 507px;">
							楦头库
						</div>
					</div>
					<img :class="[swimgbool[0]?'imgscale':'']" style="height: 507px;z-index: 1;" :src="img[0]">
				</div>

				<div @mouseenter="swimg(1)"
					style="position: relative;width: 226px;height: 507px; overflow: hidden;margin-bottom:30px ">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;">
						<div
							style="margin-top: 150px;margin-left: 100px; width: 5px; line-height: 260%;	font-size: 25px; font-weight: bold;height: 507px;">
							跟底库
						</div>
					</div>
					<img :class="[swimgbool[1]?'imgscale':'']" style="height: 507px;z-index: 1;" :src="img[1]">
				</div>

				<div @mouseenter="swimg(2)"
					style="position: relative;width: 226px;height: 507px; overflow: hidden;margin-bottom:30px ">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;">
						<div
							style="margin-top: 150px;margin-left: 100px; width: 5px; line-height: 260%;	font-size: 25px; font-weight: bold;height: 507px;">
							型体库
						</div>
					</div>
					<img :class="[swimgbool[2]?'imgscale':'']" style="height: 507px;z-index: 1;" :src="img[2]">
				</div>

				<div @mouseenter="swimg(3)"
					style="position: relative;width: 226px;height: 507px; overflow: hidden;margin-bottom:30px ">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;">
						<div
							style="margin-top: 150px;margin-left: 100px; width: 5px; line-height: 260%;	font-size: 25px; font-weight: bold;height: 507px;">
							配件库
						</div>
					</div>
					<img :class="[swimgbool[3]?'imgscale':'']" style="height: 507px;z-index: 1;" :src="img[3]">
				</div>

				<div @mouseenter="swimg(4)"
					style="position: relative;width: 226px;height: 507px; overflow: hidden;margin-bottom:30px ">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;">
						<div
							style="margin-top: 150px;margin-left: 100px; width: 5px; line-height: 260%;	font-size: 25px; font-weight: bold;height: 507px;">
							工艺库
						</div>
					</div>
					<img :class="[swimgbool[4]?'imgscale':'']" style="height: 507px;z-index: 1;" :src="img[4]">
				</div>

				<div @mouseenter="swimg(5)"
					style="position: relative;width: 226px;height: 507px; overflow: hidden;margin-bottom:30px ">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;">
						<div
							style="margin-top: 150px;margin-left: 100px; width: 5px; line-height: 260%;	font-size: 25px; font-weight: bold;height: 507px;">
							脚型库
						</div>
					</div>
					<img :class="[swimgbool[5]?'imgscale':'']" style="height: 507px;z-index: 1;" :src="img[5]">
				</div>







			</div>

		</adword>
		<advideo style="color: white;" title="与供应链的深度融合"
			subtitle="商家链接一键查询材料供应商家信息、上架材料及新品推荐。打通供应链，一键下单，配合订货系统，打造一站式原材料协同。" viewheight="200" :video="video">
		</advideo>


	</div>
</template>
<script>
	import firstsceenimage from '../../components/firstsceenimage.vue'
	import adword from '../../components/adword.vue'
	import bigimage from '../../static/banner4.png'
	import advideo from '../../components/advideo.vue'
	import video from '../../assets/video/与供应链的深度融合.mp4'

	export default {
		name: 'Probookclub',
		components: {
			firstsceenimage,
			adword,
			advideo,
		},
		data() {
			return {
				bigimage: bigimage,
				video: video,
				backimg: require('../../static/水印2.png'),

				blueimg: require('../../static/蓝色方块.png'),
				adimgreftop: 0,
				adimgshow: false,


				swimgbool: [false, false, false, false, false, false],
				img: [require('../../static/楦头.png'),
					require('../../static/鞋跟.png'),
					require('../../static/形体.png'),
					require('../../static/配件.png'),
					require('../../static/工艺.png'),
					require('../../static/脚型.png')
				]
			}
		},
		mounted() {

			window.addEventListener('scroll', this.scrollHandle); //绑定页面滚动事件

			this.adimgreftop = this.$refs.adimgref.offsetTop


		},
		methods: {
			scrollHandle: function(e) {
				var _this = this
				this.scrolltop = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
				//实际高度太晚了，所以要加上一个虚拟高度
				this.vscrolltop = document.documentElement.clientHeight / 4 + this.scrolltop
				//显示4ad
				if (!this.adimgshow) {
					if (this.vscrolltop > this.adimgreftop) {
						this.adimgshow = true;
					}
				}

			},
			swimg: function(index) {


				for (var i = 0; i < 6; i++) {
					if (index == i) {
						if (!this.swimgbool[index]) {
							this.$set(this.swimgbool, index, true)
						}
					} else {
						this.$set(this.swimgbool, i, false)
					}
				}

			}



		},
	}
</script>

<style>
	.imgscale {
		transform: scale(1.5);
		animation-name: scaleimg;
		animation-duration: 0.8s;
	}


	@media (min-width:1px) {
		.bookclubimge1{
			 width: 90%;
			 
		}
	}

	@media (min-width:1000px) {
		.bookclubimge1 {
			width: 570px;
			height: 590px;
		}
	}

	@keyframes scaleimg {
		0% {
			transform: scale(1);
		}

		100% {
			transform: scale(1.5);
		}
	}
</style>
